import React from 'react';
import { useHistory } from 'react-router-dom';
import { FingotiCallback } from '@fingoti/auth-js/react';
import { FingotiLoading, FingotiFullscreenStatus } from '@fingoti/components';

export const Callback = () => {
    const history = useHistory();
    const [error, setError] = React.useState(null);

    if (error) {
        return (
            <FingotiFullscreenStatus
                tagline="Sign-in failed"
                message={String(error)}
            />
        );
    }

    return (
        <FingotiCallback
            onSuccess={(session) => history.replace(session.returnTo ?? '/organisation')}
            onError={(e) => { setError(e) }}
        >
            <FingotiLoading fullHeight />
        </FingotiCallback>
    );
};
